import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsActivityTabClickedParams = {
  trail_id: number;
};

/**
 * User clicks on the activity tab to view recorded activities of the trail.
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsActivityTabClicked = ({ trail_id }: logTrailDetailsActivityTabClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail details activity tab clicked', { 'trail id': trail_id }, callback);
};

export default logTrailDetailsActivityTabClicked;
